import {ChangeDetectionStrategy, Component, InputSignal, Signal, computed, input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FormSliderComponent} from '../../../../shared/elements/form-slider/form-slider.component';
import {TranslatePipe} from '../../../../shared/pipes/translate.pipe';
import {FeedbackQuestionType} from '../../../../shared/types/generated/feedbackQuestionType';
import {FeedbackStructureQuestionFormQuestion, FeedbackStructureSliderQuestion} from '../../feedback-structure-create-update-dialog/feedback-structure-question/feedback-structure-question-form.model';
import {feedbackAnswerControlName} from '../../helpers/feedback-structure-preview-control-names';

@Component({
	selector: 'app-feedback-form-element-slider',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [FormSliderComponent, TranslatePipe],
	template: `
		<div class="d-flex align-items-center gap-3 px-2 ps-md-3">
			<span class="text-muted fs-small">{{ sliderQuestion().configuration.min_value }}</span>
			<div class="flex-grow-1">
				<app-form-slider
					[fG]="formGroup()"
					[fCN]="answerControlName()"
					[min]="sliderQuestion().configuration.min_value"
					[max]="sliderQuestion().configuration.max_value"
					[step]="sliderQuestion().configuration.step_size"
					[largeStepMarker]="sliderQuestion().configuration.large_step_marker_interval ?? sliderQuestion().configuration.step_size"
					[smallStepMarker]="sliderQuestion().configuration.small_step_marker_interval ?? sliderQuestion().configuration.step_size"
					[showSmallTicks]="sliderQuestion().configuration.show_small_step_markers"
					[showTooltip]="sliderQuestion().configuration.show_tooltip_on_handle"
					[unit]="sliderQuestion().configuration.unit ?? ''"
					[unitPositionLeft]="sliderQuestion().configuration.unit_position === 'left'"
					[errorText]="'INPUTREQUIRED' | translate"
					[hasErrorField]="true"
					[disabled]="disabled()"
				></app-form-slider>
			</div>
			<span class="text-muted fs-small">{{ sliderQuestion().configuration.max_value }}</span>
		</div>
	`,
})
export class FeedbackFormElementSliderComponent {
	public question: InputSignal<FeedbackStructureQuestionFormQuestion> = input.required();
	public formGroup: InputSignal<FormGroup> = input.required();
	public controlNamePrefix: InputSignal<string> = input('preview');
	public disabled: InputSignal<boolean> = input(false);

	public sliderQuestion: Signal<FeedbackStructureSliderQuestion> = computed(() => {
		const question = this.question();
		if (question.type !== FeedbackQuestionType.SLIDER) {
			throw new Error('FeedbackFormElementSliderComponent requires a slider question.');
		}

		return question;
	});

	public answerControlName(): string {
		return feedbackAnswerControlName(this.question(), this.controlNamePrefix());
	}
}
